import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import { PaymentMethods as PaymentMethodsComponent } from "ui/organizms/Setup";

const PaymentMethods = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Setup | Payment methods'
    >
        <PaymentMethodsComponent />
    </Screen>

);

export default memo(PaymentMethods);
